<template>
  <v-container fluid class="fill-height pa-0">
    <v-row>
      <v-col cols="12" xs="12" sm="12" md="12" lg="4" style="max-width:500px" class="ma-auto pa-10">
        <v-card outlined :loading="loading">
          <div class="justify-center">
            <div class="pt-10 v-application justify-center">
              <v-avatar height="100" width="100">
                <img v-bind:src="'/' + product.icon" />
              </v-avatar>
            </div>
            <v-card-title class="justify-center">
              {{ product.name }}
            </v-card-title>
            <v-card-subtitle class="text-center">
              {{ product.title }}
            </v-card-subtitle>
            <v-card-subtitle class="text-center">
              {{ product.description }}
            </v-card-subtitle>
            <v-card-text class="text-center">
              <v-btn @click="clickLink('ios')" elevation="4" color="ligth-gray" rounded large dark>
                <v-icon>mdi-apple</v-icon> IOS İNDİR (PRP V.)
              </v-btn>
            </v-card-text>
            <v-card-text class="text-center pa-0 ma-0">
              <v-btn @click="clickLink('and')" elevation="4" color="orange" rounded large dark>
                <v-icon>mdi-android</v-icon> ANDROID İNDİR (PRP V.)
              </v-btn>
            </v-card-text>
            <v-card-text class="text-center">
              <v-btn to="/prp/home" text x-small color="primary">
                Diğer Ürünlerin Prp Versiyonları
              </v-btn>
            </v-card-text>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar">
      {{ snackbarDesc }}
      <v-btn color="white" text @click="snackbar = false" icon>
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>

import moment from 'moment'
moment.locale('tr')

import ProductService from '@/services/ProductService'
import FileService from '@/services/FileService';

export default {
  name: 'Home',
  data: () => ({
    loading: false,
    product: {},

    snackbarDesc: '',
    snackbar: false,

  }),
  methods: {

    showSnackbar(desc) {
      this.snackbarDesc = desc
      this.snackbar = true
    },

    clickLink(name) {
      var ua = navigator.userAgent;
      var checker = {
        iphone: ua.match(/(iPhone|iPod|iPad|Macintosh)/),
        blackberry: ua.match(/BlackBerry/),
        android: ua.match(/(Android|HTC)/)
      };

      if (checker.android) {
        if (name == 'and') {
          this.getTokenAND(this.product._id, this.product.androidfn, 'an')
        }
        else {
          alert('Bu link üzerinden sadece iOS (iPhone,iPad,iPod..) ile çalışan akıllı cihazlara yükleme yapılabilir.');
        }
      }
      else if (checker.iphone) {
        if (name == 'ios') {
          this.getTokenIOS(this.product._id, this.product.iosfn, 'ios')
        }
        else {
          alert('Bu link üzerinden sadece android işletim sistemi ile çalışan akıllı cihazlara yükleme yapılabilir.');
        }
      }
      else if (checker.blackberry)
        alert('Sadece iOS ve Android işletim sistemi ile çalışan akıllı cihazlara yükleme yapılabilir. Blackberry cihazlar için lütfen Globalim Destek ekibiyle irtibata geçiniz.');
      else {
        alert('Sadece iOS ve Android işletim sistemi ile çalışan akıllı cihazlara yükleme yapılabilir.');
      }
    },

    async getProduct(id) {

      this.loading = true

      const product = await ProductService.getById(id)
        .catch((err) => {
          this.showSnackbar(err)
        })
        .finally(() => {
          this.loading = false
        })

      this.product = product.data.data

      if (typeof product === 'undefined') this.showSnackbar('Ürün Bulunamadı')

    },
    dateFormatter(date) {
      return moment(date).fromNow()
    },
    async downloadItem(id, fileName, os) {
      FileService.downloadDocument(id, fileName, os)
    },

    async getTokenIOS(id, fileName, os) {

      const rs = await FileService.getFileToken({ id: id, os: os })
        .catch((err) => {
          this.showSnackbar(err)
        })
        .finally(() => {
          this.loading = false
        })

      const token = rs.data.data.token

      const subUrl = rs.data.data.url + "?token=" + token

      const encodedURL = encodeURIComponent(subUrl);

      const url = "itms-services://?action=download-manifest&url=" + encodedURL

      document.location.href = url

    },

    async getTokenAND(id, fileName, os) {

      const rs = await FileService.getFileToken({ id: id, fileName: fileName, os: os })
        .catch((err) => {
          this.showSnackbar(err)
        })
        .finally(() => {
          this.loading = false
        })

      const token = rs.data.data.token

      const url = rs.data.data.url + "?token=" + token

      document.location.href = url

    },
  },
  mounted() {
    this.getProduct(this.$route.params.id)
  }
}
</script>

<style lang="scss">
.card {
  background: #f9f9f9 !important;
}
</style>
